import { useEffect, useState } from "react";

// Public reading never depends on the customer's authenticated session.
export default function PublicBlog() {
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const path = window.location.pathname.replace(/\/$/, "");
    const slug = path === "/blog" ? "" : path.slice(6);
    const valid = path === "/blog" || /^\/blog\/[a-z0-9][a-z0-9-]{0,149}$/.test(path);
    const oldTitle = document.title;
    const previous = Array.from(document.head.querySelectorAll('link[rel="canonical"],meta[name="description"],meta[name="robots"],meta[property^="og:"],meta[name^="twitter:"]')).map(n => n.cloneNode(true));
    const clear = () => document.head.querySelectorAll('link[rel="canonical"],meta[name="description"],meta[name="robots"],meta[property^="og:"],meta[name^="twitter:"],script[data-public-blog]').forEach(n => n.remove());
    const fail = () => {
      clear();
      const meta = document.createElement("meta"); meta.name = "robots"; meta.content = "noindex,follow"; document.head.appendChild(meta);
      document.title = "Article indisponible | LBC Agent"; setError(true);
    };
    if (!valid) fail();
    else fetch('/api/blog/render' + (slug ? '/' + slug : ''), { signal: controller.signal, credentials: 'omit' })
      .then(response => { if (!response.ok) throw new Error('PUBLIC_BLOG_UNAVAILABLE'); return response.text(); })
      .then(html => {
        if (controller.signal.aborted) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('h1') || !doc.querySelector('link[rel="canonical"]')) throw new Error('INVALID_BLOG_PAGE');
        clear(); document.title = doc.title;
        doc.head.querySelectorAll('link[rel="canonical"],meta[name="description"],meta[name="robots"],meta[property^="og:"],meta[name^="twitter:"]').forEach(n => document.head.appendChild(n.cloneNode(true)));
        doc.querySelectorAll('script[type="application/ld+json"]').forEach(n => { const script = n.cloneNode(true); script.setAttribute('data-public-blog', 'true'); document.head.appendChild(script); });
        // Only the server's public renderer supplies this sanitized body.
        doc.body.querySelectorAll('script').forEach(n => n.remove());
        setPage({ css: Array.from(doc.head.querySelectorAll('style')).map(n => n.textContent).join('\n'), html: doc.body.innerHTML });
      }).catch(() => { if (!controller.signal.aborted) fail(); });
    return () => { controller.abort(); clear(); previous.forEach(n => document.head.appendChild(n)); document.title = oldTitle; };
  }, []);
  if (error) return <main className="p-8"><h1>Article indisponible</h1><p>Ce guide ne peut pas être affiché pour le moment.</p><a href="/blog/">Retour au blog</a></main>;
  if (!page) return <main className="p-8" role="status">Chargement du journal…</main>;
  return <><style>{page.css}</style><div data-testid="public-blog-content" dangerouslySetInnerHTML={{ __html: page.html }} /></>;
}
